import { render } from "./categoryCreate.vue?vue&type=template&id=2c1ef999"
import script from "./categoryCreate.vue?vue&type=script&lang=js"
export * from "./categoryCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\projects\\admin-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__